import { BarChart, BookOpen, Calendar, CreditCard, FileText, MessageSquare, Shield, Sparkles, Target, Users, Zap } from 'lucide-react';
import React, { useState } from 'react';
import WaitlistModal from './WaitlistModal';

const InfoPage = () => {
  const [waitlistOpen, setWaitlistOpen] = useState(false);
  return (
    <div className="min-h-screen bg-white pt-20"> {/* Added pt-20 for navbar space */}

      {/* Hero Section */}
      <section className="pt-32 pb-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center mb-16">
            <div onClick={() => setWaitlistOpen(true)} className="inline-flex items-center space-x-2 bg-purple-100 rounded-full px-4 py-2 mb-6 cursor-pointer">
              <Sparkles className="h-4 w-4 text-purple-600" />
              <span className="text-sm text-purple-600 font-medium">Join a growing community</span>
            </div>
            <h1 className="text-5xl md:text-7xl font-bold mb-8 bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
              Join Our Community
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              Whether you're sharing knowledge or seeking growth, skillhub connects you with the right people.
            </p>
          </div>
        </div>
      </section>

      {/* Experts Section */}
      <section className="py-24 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-5xl font-bold mb-6">Experts</h2>
            <p className="text-xl text-gray-600 mb-12">
              Share your skill, get paid, and build your career - all on your terms.
            </p>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                {
                  icon: <Users />,
                  title: 'Global Student Network',
                  description: 'Connect with motivated learners from around the world seeking your expertise.'
                },
                {
                  icon: <Target />,
                  title: 'Flexible Teaching',
                  description: 'Choose between 1:1 sessions or group classes. Set your own schedule and rates.'
                },
                {
                  icon: <Shield />,
                  title: 'Professional Platform',
                  description: 'Access enterprise-grade video conferencing and teaching tools.'
                },
                {
                  icon: <BarChart />,
                  title: 'Growth Analytics',
                  description: 'Track your performance and student progress with detailed analytics.'
                },
                {
                  icon: <Zap />,
                  title: 'AI Assistance',
                  description: 'Leverage AI tools to create engaging course materials and improve your teaching.'
                },
                {
                  icon: <CreditCard />,
                  title: 'Secure Payments',
                  description: 'Receive payments reliably with our secure payment processing system.'
                }
              ].map((item, index) => (
                <div key={index} className="bg-gradient-to-br from-white to-purple-50 p-8 rounded-2xl shadow-lg border border-purple-100">
                  <div className="text-purple-600 mb-4">
                    <div className="p-2 bg-purple-50 rounded-lg w-fit">
                      {item.icon}
                    </div>
                  </div>
                  <h3 className="text-xl font-bold mb-4">{item.title}</h3>
                  <p className="text-gray-600">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Learners Section */}
      <section className="py-24">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl md:text-5xl font-bold mb-6">Learners</h2>
            <p className="text-xl text-gray-600 mb-12">
              Transform your journey with personalized guidance from verified experts.
            </p>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                {
                  icon: <Users />,
                  title: 'Flexible Learning Options',
                  description: 'Choose between private 1:1 sessions or join interactive group classes.'
                },
                {
                  icon: <Calendar />,
                  title: 'Smart Scheduling',
                  description: 'Book sessions that fit your schedule with automatic timezone handling.'
                },
                {
                  icon: <Shield />,
                  title: 'Premium Learning Environment',
                  description: 'Experience high-quality video sessions with integrated learning tools.'
                },
                {
                  icon: <FileText />,
                  title: 'Comprehensive Resources',
                  description: 'Access session recordings, notes, and supplementary materials anytime.'
                },
                {
                  icon: <MessageSquare />,
                  title: 'Direct Expert Access',
                  description: 'Message your experts directly for questions and quick feedback.'
                },
                {
                  icon: <BookOpen />,
                  title: 'AI-Enhanced Materials',
                  description: 'Study with AI-generated materials curated by your expert.'
                }
              ].map((item, index) => (
                <div key={index} className="bg-gradient-to-br from-white to-purple-50 p-8 rounded-2xl shadow-lg border border-purple-100">
                  <div className="text-purple-600 mb-4">
                    <div className="p-2 bg-purple-50 rounded-lg w-fit">
                      {item.icon}
                    </div>
                  </div>
                  <h3 className="text-xl font-bold mb-4">{item.title}</h3>
                  <p className="text-gray-600">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <WaitlistModal isOpen={waitlistOpen} onClose={() => setWaitlistOpen(false)} />
    </div>
  );
};

export default InfoPage;
